import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../store";

interface InitialState {
  status: "fulfilled" | "pending" | "rejected";
  isAdminAuthenticated: boolean;
}

const initialState: InitialState = {
  isAdminAuthenticated: false,
  status: "fulfilled",
};

// export const loginAdmin = createAsyncThunk(
//   "admin/loginAdmin",
//   adminAPI.loginAdmin
// );
// export const checkSession = createAsyncThunk(
//   "admin/checkSession",
//   adminAPI.checkSession
// );
// export const logoutAdmin = createAsyncThunk(
//   "admin/logoutAdmin",
//   adminAPI.logoutAdmin
// );

const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    setIsAdminAuthenticated(state, action: PayloadAction<boolean>) {
      state.isAdminAuthenticated = action.payload;
    },
    setStatus(state, action: PayloadAction<InitialState["status"]>) {
      state.status = action.payload;
    },
  },
  // extraReducers: (builder) => {
  //   builder
  //     .addCase(loginAdmin.fulfilled, (state) => {
  //       state.status = "fulfilled";
  //       state.isAdminAuthenticated = true;
  //     })
  //     .addCase(loginAdmin.pending, (state) => {
  //       state.status = "pending";
  //       state.isAdminAuthenticated = false;
  //     })
  //     .addCase(loginAdmin.rejected, (state, error) => {
  //       state.status = "rejected";
  //       state.isAdminAuthenticated = false;
  //       // console.error(error);
  //     })
  //     .addCase(checkSession.fulfilled, (state) => {
  //       state.status = "fulfilled";
  //       state.isAdminAuthenticated = true;
  //     })
  //     .addCase(checkSession.pending, (state) => {
  //       state.status = "pending";
  //       state.isAdminAuthenticated = false;
  //     })
  //     .addCase(checkSession.rejected, (state, error) => {
  //       state.status = "rejected";
  //       state.isAdminAuthenticated = false;
  //       // console.error(error);
  //     })
  //     .addCase(logoutAdmin.fulfilled, (state) => {
  //       state.status = "fulfilled";
  //       state.isAdminAuthenticated = false;
  //     })
  //     .addCase(logoutAdmin.pending, (state) => {
  //       state.status = "pending";
  //       state.isAdminAuthenticated = false;
  //     })
  //     .addCase(logoutAdmin.rejected, (state, error) => {
  //       state.status = "rejected";
  //       state.isAdminAuthenticated = false;
  //       // console.error(error);
  //     });
  // },
});

export const selectAdminStatus = (state: RootState) => state.admin.status;
export const selectIsAdminAuthenticated = (state: RootState) =>
  state.admin.isAdminAuthenticated;

export const adminActions = adminSlice.actions;
export const adminReducer = adminSlice.reducer;
